import { captureClientError } from './sentry'
const failedImports = new WeakSet()
export function isChunkLoadError(error) {
  return Boolean(error && typeof error === 'object' && failedImports.has(error)) || /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|loading (?:css )?chunk .*failed|unable to preload css/i.test(error?.message ?? '')
}
export function installChunkErrorReporting() {
  const report = (event) => {
    const error = event.payload
    if (error && typeof error === 'object') failedImports.add(error)
    captureClientError(error, 'dynamic-import')
    // Keep the original error available to the router. Never reload an open editor.
  }
  window.addEventListener('vite:preloadError', report)
  return () => window.removeEventListener('vite:preloadError', report)
}
